var map = {
	"./available-location-opacity.svg": "e058",
	"./available-location.svg": "be58",
	"./bike-black.svg": "a818",
	"./bike.svg": "3280",
	"./clock.svg": "6f83",
	"./customer.svg": "33a7",
	"./unavailable-location-opacity.svg": "b010",
	"./unavailable-location.svg": "015c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b9fc";